<template>
  <base-layout
    :value="value"
    :label-width="labelWidth"
    :text-align="textAlign"
    :is-require="isRequire"
    :is-dipatch="isDipatch"
    :label="label"
    :labelPaddingRight="labelPaddingRight"
  >
    <template v-if="multiple">
      <div slot="control">
        <template v-if="allCheck === true">
          <el-row>
            <el-checkbox v-model="checkAll" label="全选" @change="handleAllChange"></el-checkbox>
          </el-row>
        </template>
        <el-checkbox-group :min="min" :max="max" v-model="inputValue">
          <compoment
            :key="`${$index}--checkbox`"
            v-for="(item, $index) in getOptions"
            :span="6"
            :is="controlTagName"
          >
            <el-checkbox
              class="base-input-value__checkgroup"
              :disabled="item.disabled || readOnly"
              :label="item.comment"
              @change="value => handleSelectValue(value, item)"
            ></el-checkbox>
          </compoment>
          <!-- <el-col >
          </el-col>-->
        </el-checkbox-group>
      </div>
    </template>
    <template v-else>
      <el-checkbox
        @change="handleChange"
        slot="control"
        v-model="inputValue"
        :disabled="disabled || readOnly"
        :label="iconLabel"
      ></el-checkbox>
    </template>
  </base-layout>
</template>

<script>
import baseLayout from "./base-layout.vue";
import { handleEmitValue, datePicker } from "./../props-config";
import { baseCheckbox } from "./../props-config";
import * as API from "./base-enum-remote";

export default {
  name: "base-checkbox",
  components: {
    baseLayout
  },
  computed: {
    inputValue: {
      get() {
        if (this.multiple === false) return !!this.value;
        // this.valueType
        if (this.valueType == 0) {
          let array = [];
          try {
            array = JSON.parse(this.value);
          } catch (e) {
            array = this.value;
          }
          if (Array.isArray(array)) {
            return array.map(item => {
              if (item.hasOwnProperty("comment")) {
                return item.comment;
              } else {
                return item;
              }
            });
          } else {
            return [];
          }
        } else {
          return (
            this.getOptions
              .filter(item => item.code == this.value)
              .map(item => item.comment) || null
          );
        }
      },
      set(val) {
        let setVal;
        if (this.multiple === false) return this.$emit("input", val ? 1 : 0);
        const getSelectValue = (pre, next) => {
          const getOptions = this.getOptions;
          const index = getOptions.findIndex(item => next == item.comment);
          if (index > -1) pre.push(getOptions[index]);
          return pre;
        };
        const getOptionsValue = (pre, next) => {
          const getOptions = this.getOptions;
          const index = getOptions.findIndex(item => next == item.comment);
          if (index > -1) return getOptions[index].code;
          return pre;
        };
        if (this.valueType === 0) {
          setVal = val.reduce(getSelectValue, []);
        } else {
          this.$emit("input");
          setVal = val.reduce(getOptionsValue, null);
        }
        if (this.isDipatch) {
          this.$store.dispatch("updateObject", {
            obj: this.dipatchObj,
            attr: this.dipatchAttr,
            val: setVal
          });
        } else {
          this.$emit("input", setVal);
        }
      }
    },
    getOptions() {
      // 如果是拉去服务器下拉
      if (this.apiName) {
        return this.list;
      } else {
        return this.options;
      }
    }
  },
  props: {
    ...baseCheckbox,
    multiple: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    apiName: {
      type: String,
      default: ""
    },
    iconLabel: {
      type: String,
      default: ""
    },
    // 接受固定参数,
    params: {
      type: Object,
      default: () => ({})
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 99
    },
    // 1 -> 竖 2-> 横
    controlTagName: {
      type: [String],
      default: "el-col"
    },
    allCheck: {
      type: true,
      default: false
    },
    // 0 -> 接受数组
    // 1 -> 接收Boolean
    // 2 -> 返回数字类型
    valueType: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    handleEmitValue,
    handleChange(val) {
      this.handleEmitValue(val)
    },
    handleSelectValue(val, opt) {
      this.handleEmitValue({val, opt})
    },
    handleAllChange() {
      if (!this.checkAll) {
        this.$emit("input", []);
      } else {
        if (this.valueType === 0) {
          this.$emit("input", this.getOptions);
        }
      }
    },
    // 拉去固定参数的数据
    syncGetOptions(params) {
      return API.syncGetEnum(this.apiName, params).then(res => {
        this.list = res;
      });
    },
    init() {
      if (this.apiName) {
        this.syncGetOptions(this.params);
      }
    }
  },
  data() {
    return {
      list: [],
      checkAll: false
    };
  }
};
</script>

<style>
.base-input-value__checkgroup {
  margin-right: 20px;
}
/* .el-checkbox__inner::after {
		background-color: #fff;
	}
	.el-checkbox__inner::before {
		position: absolute;
		content: '';
		width: 4px;
		height: 8px;
		background-color: red;
		left: 5px;
		top: 1px;
	} */
</style>
